import React, { useState } from 'react';
import { Box } from '@mui/material';
import { useGetOrders } from '@hooks/useOrders';
import Loader from '@components/loader/Loader';
import { OrdersContext } from '@contexts/OrdersContext';
import Orders from '@pages/tickets/orders/Orders';

const OrdersPage = () => {
  const [pageNumber, setPageNumber] = useState(0);
  const { data, isFetching } = useGetOrders(pageNumber);

  return (
    <OrdersContext.Provider value={{ data, pageNumber, setPageNumber }}>
      <Box
        sx={{
          pt: { xs: '29px', md: '26px' },
          pl: { xs: '8px', sm: '20px', md: '46px' },
          pr: { xs: '8px', sm: '20px', md: '0' },
          maxWidth: {
            md: '486px',
            lg: '779px',
            xl: '1100px',
            xxl: '1739px',
          },
        }}
      >
        {isFetching ? <Loader isShowLoader /> : <Orders consistType="TICKET" />}
      </Box>
    </OrdersContext.Provider>
  );
};

export default OrdersPage;
